import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    
    react: {
      useSuspense: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false,
    },

    // Namespaces
    ns: ['common', 'hero', 'navigation', 'faq', 'pricing', 'social', 'promise', 'whatyouget', 'whywebfast', 'usecases', 'finalcta', 'footer', 'dashboard', 'campaign'],
    defaultNS: 'common',

    // Supported languages
    supportedLngs: ['en', 'es', 'fr', 'de', 'pt', 'it', 'nl', 'sk', 'uk', 'ru', 'cs', 'sr', 'hr'],
    
    // Preload English to ensure it loads
    preload: ['en'],
  });

export default i18n;